import { post } from './api';

/** Who a broadcast targets. */
export type BroadcastScope = 'all' | 'organizations' | 'devices' | 'user';

export interface BroadcastNotificationRequest {
  title: string;
  body: string;
  scope: BroadcastScope;
  /** Required when scope is "organizations". */
  organizationIds?: string[];
  /** Required when scope is "devices". */
  deviceTokens?: string[];
  /** Required when scope is "user". */
  userEmail?: string;
}

export interface BroadcastNotificationResult {
  targeted: number;
  delivered: number;
  failed: number;
  pruned: number;
  /** Distinct failure reasons (FCM error code + message) when any sends failed. */
  errors: string[];
}

/**
 * System-admin only. Sends an ad-hoc push notification to every registered device,
 * the devices of specific organizations, or an explicit list of device tokens.
 * Mainly used to test delivery.
 */
export const sendBroadcastNotification = (
  request: BroadcastNotificationRequest,
): Promise<BroadcastNotificationResult> =>
  post<BroadcastNotificationResult>('/api/admin/notifications/broadcast', request);
